import React from "react";
import { Box, Container, Typography, Grid, Button } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useNavigate } from "react-router-dom";
import patternBgImg from "../../../assets/images/pattern-bg-img.png";

const TourItinerarySection = ({ title, image, itinerary, footer }) => {
    const navigate = useNavigate();

    return (
        <Box sx={{ background: "#2b5c9e", pb: 6 }}>

            {/* 🔹 IMAGE SECTION */}
            <Container maxWidth="lg">
                <Grid container>
                    <Grid size={{ xs: 12, md: 12 }}>
                        <Box
                            sx={{
                                mt: 4,
                                borderRadius: "18px",
                                overflow: "hidden",
                                boxShadow: "0 0 0 6px rgba(255,255,255,0.2)",
                                background: "#fff",
                            }}
                        >
                            <Box
                                component="img"
                                src={image}
                                alt="tour"
                                sx={{
                                    width: "100%",
                                    height: { xs: 320, md: 460 },
                                    objectFit: "fill",
                                    display: "block",
                                }}
                            />
                        </Box>
                    </Grid>
                </Grid>
            </Container>

            {/* 🔹 CONTENT SECTION */}
            <Box sx={{ position: "relative", mt: 5 }}>

                {/* BACKGROUND PATTERN */}
                <Box
                    sx={{
                        position: "absolute",
                        inset: 0,
                        backgroundImage: `url(${patternBgImg})`,
                        opacity: 0.08,
                    }}
                />

                <Container maxWidth="lg" sx={{ position: "relative" }}>

                    {/* 🔹 TITLE */}
                    <Typography
                        sx={{
                            color: "#fff",
                            fontWeight: 700,
                            fontSize: { xs: "20px", md: "28px" },
                            mb: 3,
                        }}
                    >
                        {title}
                    </Typography>

                    {/* 🔹 ITINERARY */}
                    {itinerary?.map((day, i) => (
                        <Box key={i} sx={{ mb: 4 }}>

                            {/* DAY TITLE */}
                            <Typography
                                sx={{
                                    color: "#fff",
                                    fontWeight: 700,
                                    fontSize: "14px",
                                    mb: 1,
                                }}
                            >
                                {day.day}
                            </Typography>

                            {/* ALL LINES */}
                            {day.lines?.map((line, idx) => {
                                const isService = line.startsWith("Day Services");
                                const isAttraction = line.startsWith("Major Attractions");
                                const isNote = line.startsWith("Note");
                                const isOption = line.startsWith("Option");

                                return (
                                    <Typography
                                        key={idx}
                                        sx={{
                                            color:
                                                isService || isAttraction
                                                    ? "#f5b400" // yellow
                                                    : "#fff",
                                            fontWeight:
                                                isService || isAttraction ? 700 : 400,
                                            fontSize: "12px",
                                            lineHeight: 1.6,
                                            mt: isNote || isOption ? 1 : 0.5,
                                        }}
                                    >
                                        {line}
                                    </Typography>
                                );
                            })}
                        </Box>
                    ))}

                    {/* 🔴 FOOTER */}
                    {footer?.map((item, i) => (
                        <Typography
                            key={i}
                            sx={{
                                color: "#ff3b30",
                                fontWeight: 700,
                                mt: 1,
                                fontSize: "13px",
                            }}
                        >
                            {item}
                        </Typography>
                    ))}

                    <Box
                        sx={{
                            display: "inline-flex",
                            borderRadius: "10px",
                            border: "4px solid rgba(255,255,255,0.3)",
                            mt: 2,
                        }}
                    >
                        <Box
                            onClick={() => navigate("/contact-us")}
                            sx={{
                                display: "flex",
                                overflow: "hidden",
                                borderRadius: "6px",
                            }}
                        >
                            {/* MAIN BUTTON */}
                            <Button
                                sx={{
                                    background: "#f5b400",
                                    color: "#fff",
                                    px: 3,
                                    py: 1,
                                    fontWeight: 700,
                                    textTransform: "none",
                                    borderRadius: "0",
                                    "&:hover": {
                                        background: "#e0a200",
                                    },
                                }}
                            >
                                Contact Now
                            </Button>

                            {/* ICON PART */}
                            <Box
                                sx={{
                                    background: "#e0a200",
                                    px: 2,
                                    display: "flex",
                                    alignItems: "center",
                                }}
                            >
                                <ArrowForwardIcon sx={{ color: "#fff" }} />
                            </Box>
                        </Box>
                    </Box>
                </Container>
            </Box>
        </Box>
    );
};

export default TourItinerarySection;